import { employeeNotificationsMarkAsReadApi } from './markAsRead';

export function employeeNotificationApi(path: string) {
  return {
    path,
    markAsRead: () => employeeNotificationsMarkAsReadApi(`${path}/mark-as-read`),
  };
}
